import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_APPRAISAL_TYPES](state, data) {
    console.log('mutation ', data)
    state.allAppraisalTypes = data
  },
}
